import React from 'react'
import { useUtilities } from '@ten24/slatwall-storefront-react-private/global'

const ActionBanner = ({ contentHeading,contentSubHeading, contentBody = '', linkLabel = '', linkUrl = '', systemCode, style, bootStrapLayoutClass, ctaBackgroundImage }) => {
  let { eventHandlerForWSIWYG } = useUtilities()
  if (!contentHeading) return null
  return (
    <div className={`bg-light-blue p-5 action-banner-sec ${style.toLowerCase()} ${bootStrapLayoutClass}`} style={ctaBackgroundImage ? {backgroundImage: `url(${ctaBackgroundImage})`, backgroundSize: "cover"}:{}}>
      <div className="container">
        <div className="row">
          <div className="col-0 col-md-2" />
          <div className="col-md-8 text-center">
            {!!contentHeading && (
              <header className="section-title">
                <h2>{contentHeading}</h2>
                <h5>{contentSubHeading}</h5>
              </header>
            )}
            <div onClick={eventHandlerForWSIWYG} dangerouslySetInnerHTML={{ __html: contentBody }} />
            {!!linkLabel && (
              <a className="btn btn-primary" href={linkUrl}>
                {linkLabel}
              </a>
            )}
          </div>
          <div className="col-0 col-md-2" />
        </div>
      </div>
    </div>
  )
}

export { ActionBanner }
